/**
 * 미리보기 페이지/슬라이드 네비게이션 레지스트리 (chat-doc-preview-rail — 2026-08-11).
 *
 * 좌/우 썸네일 레일은 패널 쪽 컴포넌트인데, 실제 페이지를 그리는 주체는 포맷별 렌더러
 * (PdfPreview·PptxPreview) 다. 렌더러를 들어내지 않고 레일을 붙이기 위해, 렌더러가 "몇 장인지 ·
 * 어떻게 썸네일을 그리는지 · 어떻게 이동하는지"를 이 레지스트리에 등록하고 레일이 구독한다.
 *
 * 한 번에 한 문서만 미리보기하므로 단일 entry(전역 1개). 렌더러가 언마운트될 때는 자기 것이
 * 맞을 때만 해제한다(문서 A→B 전환 시 B 등록 후 A 의 cleanup 이 도는 순서 경합 방지).
 */
import { create } from 'zustand';

export interface PreviewNavSource {
  /** 소유 문서 식별자(PreviewDoc.key) — 해제 시 소유권 확인용. */
  key: string;
  /** 전체 페이지/슬라이드 수. */
  count: number;
  /** 해당 인덱스로 스크롤 이동. */
  goTo: (index: number) => void;
  /**
   * host 엘리먼트 안에 index 번째 썸네일을 그린다.
   * 정리 함수를 돌려주면 레일이 썸네일을 버릴 때 호출한다(렌더러 핸들 dispose 등).
   */
  drawThumb: (index: number, host: HTMLElement) => (() => void) | void;
}

interface PreviewNavState {
  source: PreviewNavSource | null;
  /** 현재 보고 있는 페이지 인덱스(0-base) — 레일에서 강조 표시. */
  activeIndex: number;
  setSource: (s: PreviewNavSource) => void;
  /** key 가 현재 소스와 같을 때만 해제 — 문서 전환 시 새 소스를 지우지 않는다. */
  clearSource: (key: string) => void;
  setActiveIndex: (i: number) => void;
}

export const usePreviewNavStore = create<PreviewNavState>((set) => ({
  source: null,
  activeIndex: 0,
  setSource: (s) => set({ source: s, activeIndex: 0 }),
  clearSource: (key) => set((st) => (st.source?.key === key ? { source: null, activeIndex: 0 } : st)),
  setActiveIndex: (i) => set((st) => (st.activeIndex === i ? st : { activeIndex: i })),
}));
